export const enum ReportFilterType {
  Text = 'text',
  Number = 'number',
  Date = 'date',
}
